const {
  zipCodeRegexNumeric,
  onlyNumericNormalize,
  SPACE
} = require('../helpers');

exports.zipCodeNormalize = (zipCode) => onlyNumericNormalize(zipCode, 5);

exports.countryDefinition = {
  country: 'French Polynesia',
  code: 'PF',
  schema: {
    company: { label: 'Company' },
    address: { label: 'Address' },
    address2: { label: 'Address 2' },
    city: { label: 'Town', width: 0.5 },
    zipCode: {
      label: 'Postcode',
      width: 0.5,
      normalize: exports.zipCodeNormalize
    }
  },
  viewFormat: [
    ['company'],
    ['address'],
    ['address2'],
    ['zipCode', SPACE, 'city']
  ],
  formFormat: [['company'], ['address'], ['address2'], ['zipCode', 'city']],
  requiredFormFields: [
    { field: 'address' },
    { field: 'city' },
    {
      field: 'zipCode',
      validationRegex: new RegExp(zipCodeRegexNumeric(5)),
      error: 'Must be 5 numbers like 98709'
    }
  ]
};
